import { Card, CardContent, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import { lookUpTranslatedDescription } from "../../utils/article";
import i18n from "../../i18n";

const useStyles = makeStyles((theme) => ({
    articleCard: {
        borderRadius: 10
    },
    valueWrapper: {
        borderRadius: 8,
        backgroundColor: theme.palette.secondary.light,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.palette.secondary.dark,
        textAlign: 'center'
    },
    valueField: {
        fontWeight: 'bold',
        padding: '0 1rem !important'
    }
}));

export const ArticleSummaryCard = ({
    article,
    quantityIn,
    quantityOut
}) => {
    const classes = useStyles();

    return (
        <Card elevation={2} className={classes.articleCard}>
            <CardContent>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={8} md={10}>
                        <Typography variant="h6">{article.name}</Typography>
                        <Typography variant="body2">{lookUpTranslatedDescription(article, i18n.language)}</Typography>
                    </Grid>
                    <Hidden smUp>
                        <Grid item xs={6} sm={8} md={10}></Grid>
                    </Hidden>
                    <Grid item xs={3} sm={2} md={1}>
                        {
                            article.displayIn ? 
                                <Grid container justifyContent="center" className={classes.valueWrapper}>
                                    <Typography color="secondary" className={classes.valueField}>{quantityIn ?? 0}</Typography>
                                </Grid>
                                : null
                        }
                    </Grid>
                    <Grid item xs={3} sm={2} md={1}>
                        {
                            article.displayOut ? 
                                <Grid container justifyContent="center" className={classes.valueWrapper}>
                                    <Typography color="secondary" className={classes.valueField}>{quantityOut ?? 0}</Typography>
                                </Grid>
                                : null
                        }
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );

}